import BenchlingConfig from 'BenchlingConfig';

/**
 * Whether the Agents (routines) UI should be available. Agents require the assistant agent and at
 * least one routine trigger type (time-based or event-based); without a trigger type, an agent
 * cannot be created. Gate every Agents entry point (sidebar nav, settings tabs) on this so we never
 * surface an entry point that leads to a non-functional Agents surface.
 */
export function isAgentsFeatureEnabled(): boolean {
  return (
    BenchlingConfig.LLM_ENABLE_ASSISTANT_AGENT &&
    (BenchlingConfig.LLM_ENABLE_ROUTINES_TIME_BASED || BenchlingConfig.LLM_ENABLE_ROUTINES_EVENT_BASED)
  );
}
